let accountOpeningDomain= "https://opentrader.com.au/account-opening/";

export default accountOpeningDomain;
